import React from 'react';
import { ErrorBar, LoadingBar } from 'ui/NetworkStatusBar';
import { ITaMetricsResponse } from 'services/DashboardApi/types';
import { TaMetricsChart } from './charts/TaMetricsChart';
import { HidingTooltip } from 'ui/Tooltip';
import { InfoTransparentIcon } from 'ui/Icons/components/InfoTransparent.component';
import { theme } from '../../../../../tailwind.config';
import { MetricsTooltip } from './MetricsTooltip';
import { TA_METRICS_TOOLTIP_ITEMS } from './tooltipData';

interface ITaMetricsDataProps {
  taMetricsData?: ITaMetricsResponse;
  isLoadingTaMetricsData: boolean;
  isErrorTaMetricsData: boolean;
}

export const TaMetricsData: React.FC<ITaMetricsDataProps> = ({
  taMetricsData,
  isLoadingTaMetricsData,
  isErrorTaMetricsData,
}) => {
  if (isErrorTaMetricsData) {
    return (
      <div className="border border-solid border-gray-20 w-full flex flex-col justify-center items-center mt-5 mb-5">
        <div className="bg-white p-[20px] rounded">
          <div className="flex items-center justify-center gap-[5px] mb-[4px]">
            <p className="m-0 font-pt-sans text-[13px] leading-[22px] tracking-[0.52px] uppercase text-black">
              Travel Agent Metrics
            </p>
            <HidingTooltip position="bottom-right" width="220px" renderTooltipContent={() => <MetricsTooltip items={TA_METRICS_TOOLTIP_ITEMS} />}>
              <InfoTransparentIcon width={16} height={16} fill={theme.colors['gray-60']} />
            </HidingTooltip>
          </div>
        </div>
        <div className="w-full flex justify-center items-center mt-[30px] mb-[30px]">
          <ErrorBar />
        </div>
      </div>
    );
  }

  if (isLoadingTaMetricsData || !taMetricsData) {
    return (
      <div className="w-full flex justify-center items-center mt-5 mb-5">
        <LoadingBar label="Loading" />
      </div>
    );
  }

  const byMonthData = taMetricsData.byMonth ?? [];

  return (
    <div className="border border-solid border-gray-20">
      <TaMetricsChart taMetricsByMonth={byMonthData} />
    </div>
  );
};
